// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__nCARn","buttons":"SendReceipts_buttons__32R97","email":"SendReceipts_email__3GxSi","bookApptTitle":"SendReceipts_bookApptTitle__1aKqR"};